import { useField } from "formik";
import { FormNumberInput } from "@jsq/ds/forms";
import { joinPath } from "./paths";
import { trailingMonthsHelpText } from "./periodHelpText";
import * as styles from "./styles_vanilla.css";

type TrailingBodyProps = {
  valuesPath: string;
  isReadOnly?: boolean;
};

/** Body for `TRAILING_MONTHS` — number input with kind-specific help text. */
export const TrailingBody = ({ valuesPath, isReadOnly = false }: TrailingBodyProps) => {
  const trailingMonthsName = joinPath(valuesPath, "trailingMonths");
  const [{ value: trailingMonths }] = useField<number | null>(trailingMonthsName);

  return (
    <FormNumberInput
      name={trailingMonthsName}
      label="Trailing months"
      helpText={trailingMonthsHelpText(trailingMonths)}
      className={styles.formControl}
      data-testid="date-period-trailing-months"
      disabled={isReadOnly}
      min={1}
      step={1}
    />
  );
};
